import { ShipmentOverviewPage, ShipmentDetailPage } from "@clubInventory/shipment/";
import { CLUB_INVENTORY_ROUTER } from "./routerPath";
import { FRONT_KEY } from "@clubInventory/constants/frontKey";

/**
 * 出貨單管理路由配置
 */
const shipmentRouter = [
	{
		description: "出貨單總覽",
		path: CLUB_INVENTORY_ROUTER.SHIPMENT.OVERVIEW,
		href: CLUB_INVENTORY_ROUTER.SHIPMENT.OVERVIEW,
		as: ShipmentOverviewPage,
		exact: true,
		frontKey: FRONT_KEY.SHIPMENT_OVERVIEW,
	},
	{
		description: "出貨單明細",
		path: CLUB_INVENTORY_ROUTER.SHIPMENT.DETAIL,
		as: ShipmentDetailPage,
		exact: true,
		frontKey: FRONT_KEY.SHIPMENT_DETAIL,
	},
];

export default shipmentRouter;
